import {
  LIST_BRANCH_CONFIGURATION_REQUEST,
  LIST_BRANCH_CONFIGURATION_SUCCESS,
  LIST_BRANCH_CONFIGURATION_FAIL,
  CREATE_BRANCH_CONFIGURATION_REQUEST,
  CREATE_BRANCH_CONFIGURATION_SUCCESS,
  CREATE_BRANCH_CONFIGURATION_FAIL,
  DETAIL_BRANCH_CONFIGURATION_REQUEST,
  DETAIL_BRANCH_CONFIGURATION_SUCCESS,
  DETAIL_BRANCH_CONFIGURATION_FAIL,
  UPDATE_BRANCH_CONFIGURATION_REQUEST,
  UPDATE_BRANCH_CONFIGURATION_SUCCESS,
  UPDATE_BRANCH_CONFIGURATION_FAIL,
  DELETE_BRANCH_CONFIGURATION_REQUEST,
  DELETE_BRANCH_CONFIGURATION_SUCCESS,
  DELETE_BRANCH_CONFIGURATION_FAIL,
  RESET_BRANCH_CONFIGURATION,
  LIST_BRANCH_CONFIGURATION_SUMMARY_REQUEST,
  LIST_BRANCH_CONFIGURATION_SUMMARY_SUCCESS,
  LIST_BRANCH_CONFIGURATION_SUMMARY_FAIL
} from '../../constants/branch-configuration'

const initialState = {
  loading: false,
  loadingCreate: false,
  loadingUpdate: false,
  loadingDelete: false,
  loadingDetail: false,
  loadingSummary: false,
  configurationsSummary: [],
  configurations: [],
  configuration: {},
  error: null,
  pageable: {
    page: 1,
    size: 10
  }
}

const listBranchConfigurationReducer = (state = initialState, action) => {
  switch (action.type) {
    case LIST_BRANCH_CONFIGURATION_REQUEST:
      return { ...state, loading: true }
    case LIST_BRANCH_CONFIGURATION_SUCCESS:
      return {
        ...state,
        loading: false,
        configurations: action.payload,
        pageable: action.pageable
      }
    case LIST_BRANCH_CONFIGURATION_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload
      }
    case LIST_BRANCH_CONFIGURATION_SUMMARY_REQUEST:
      return { ...state, loadingSummary: true, error: '' }
    case LIST_BRANCH_CONFIGURATION_SUMMARY_SUCCESS:
      return {
        ...state,
        configurationsSummary: action?.payload,
        loadingSummary: false
      }
    case LIST_BRANCH_CONFIGURATION_SUMMARY_FAIL:
      return {
        ...state,
        loadingSummary: true,
        error: action.payload
      }
    case CREATE_BRANCH_CONFIGURATION_REQUEST:
      return { ...state, loadingCreate: true, error: '' }
    case CREATE_BRANCH_CONFIGURATION_SUCCESS:
      return { ...state, loadingCreate: false }
    case CREATE_BRANCH_CONFIGURATION_FAIL:
      return { ...state, loadingCreate: false, error: action.payload }
    case DETAIL_BRANCH_CONFIGURATION_REQUEST:
      return { ...state, loadingDetail: true }
    case DETAIL_BRANCH_CONFIGURATION_SUCCESS:
      return { ...state, loadingDetail: false, textTemplate: action.payload }
    case DETAIL_BRANCH_CONFIGURATION_FAIL:
      return {
        ...state,
        loadingDetail: false,
        error: action.payload
      }
    case UPDATE_BRANCH_CONFIGURATION_REQUEST:
      return { ...state, loadingUpdate: true, error: '' }
    case UPDATE_BRANCH_CONFIGURATION_SUCCESS:
      return { ...state, loadingUpdate: false }
    case UPDATE_BRANCH_CONFIGURATION_FAIL:
      return { ...state, loadingUpdate: false, error: action.payload }
    case DELETE_BRANCH_CONFIGURATION_REQUEST:
      return { ...state, loadingDelete: true, error: '' }
    case DELETE_BRANCH_CONFIGURATION_SUCCESS:
      return { ...state, loadingDelete: false, error: '' }
    case DELETE_BRANCH_CONFIGURATION_FAIL:
      return { ...state, loadingDelete: false, error: action.payload }
    case RESET_BRANCH_CONFIGURATION:
      return { ...state, loading: false, error: null }
    default:
      return state
  }
}

export default listBranchConfigurationReducer
